import { NotificationService } from '@/services/notification.service';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Badge } from 'primeng/badge';
import { Observable } from 'rxjs';
import { NotificationHoverComponent } from './notification-hover/notification-hover.component';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'sm-notification',
  imports: [CommonModule, Badge, NotificationHoverComponent, Popover],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent {
  notificationService = inject(NotificationService);

  unreadCount$: Observable<number> = this.notificationService.unreadCount$;
}
